import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { IconButton } from 'components/IconButton';

import { IStudentProgramsGradeModel } from '@common/models/StudentPrograms/Grade';
import { StyledLessonStatus } from '../Status/styled';

interface PropsType {
	grade: IStudentProgramsGradeModel[];
	gradebookFinalGrade: string;
}

function ProgramsLessonGradeButton({ grade = [], gradebookFinalGrade }: PropsType) {
	const { t } = useTranslation();
	const grades = Array.isArray(grade) ? grade : [grade];

	const singleGrade = grades?.find((grade) => grade.grade)?.grade || '';

	return (singleGrade || gradebookFinalGrade) ? (
		<IconButton variant="contained" color="info">
			<Typography variant="subtitle3">{gradebookFinalGrade || singleGrade}</Typography>
		</IconButton>
	) : (
		<StyledLessonStatus
			color="success"
			label={
				<>
					<Typography variant="subtitle3">{t('program.completed')}</Typography>
					<CheckIcon />
				</>
			}
		/>
	);
}

export default ProgramsLessonGradeButton;
